import { render, staticRenderFns } from "./CardApellation.vue?vue&type=template&id=0ba2be2d"
import script from "./CardApellation.vue?vue&type=script&lang=js"
export * from "./CardApellation.vue?vue&type=script&lang=js"
import style0 from "./CardApellation.vue?vue&type=style&index=0&id=0ba2be2d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports